import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { DefaultTheme } from 'styled-components/dist/types';
import { templateStyles } from '../style';

interface PDFSectionScoreProps {
  score: number;
  templateStylingData: ITemplateStylingSettings;
  theme: DefaultTheme;
}

export const PDFSectionScore = ({ score, templateStylingData, theme }: PDFSectionScoreProps) => {
  const styles = StyleSheet.create({
    scoreWrap: {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      fontFamily: 'Sanchez',
      fontSize: '13px',
      color: templateStylingData?.headerFontStyle?.fontColor ? `#${templateStylingData?.headerFontStyle?.fontColor}` : theme.font.strong
    }
  });

  if (score > 0) {
    return (
      <View style={styles.scoreWrap}>
        <Text>Score</Text>
        <View style={{ ...templateStyles.score, backgroundColor: theme.context.success, color: theme.context.light }}>
          <Text>{`+${score}`}</Text>
        </View>
      </View>
    );
  }
  if (score === 0) {
    return (
      <View style={styles.scoreWrap}>
        <Text>Score</Text>
        <View
          style={{
            ...templateStyles.score,
            backgroundColor: '#F4F5F6',
            color: '#474747',
            border: '1px solid #474747'
          }}
        >
          <Text>{score}</Text>
        </View>
      </View>
    );
  }
  if (score < 0) {
    return (
      <View style={styles.scoreWrap}>
        <Text>Score</Text>
        <View style={{ ...templateStyles.score, backgroundColor: theme.context.error, color: theme.context.light }}>
          <Text>{score}</Text>
        </View>
      </View>
    );
  }
  return <></>;
};
